import ImagesPreview from './ImagesPreview'

export default ImagesPreview
